import { render, staticRenderFns } from "./MobileOrderDetails.vue?vue&type=template&id=2327b9d0&scoped=true"
import script from "./MobileOrderDetails.vue?vue&type=script&lang=js"
export * from "./MobileOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./MobileOrderDetails.vue?vue&type=style&index=0&id=2327b9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327b9d0",
  null
  
)

export default component.exports